import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { states } from './usStates';
import Cookies from 'js-cookie';

function ProfileForm() {
  const navigate = useNavigate();

  // Initialize form state
  const [schoolName, setSchoolName] = useState('');
  const [schoolDistrict, setSchoolDistrict] = useState('');
  const [schoolCity, setSchoolCity] = useState('');
  const [schoolState, setSchoolState] = useState('');
  const [grades, setGrades] = useState([]);
  const [ethnicities, setEthnicities] = useState([]);
  const [studentCountries, setStudentCountries] = useState('');
  const [studentInterests, setStudentInterests] = useState('');

  // Load from cookie if exists
  useEffect(() => {
    const cookieData = Cookies.get('teacherProfile');
    if (cookieData) {
      try {
        const parsed = JSON.parse(cookieData);
        setSchoolName(parsed.schoolName || '');
        setSchoolDistrict(parsed.schoolDistrict || '');
        setSchoolCity(parsed.schoolCity || '');
        setSchoolState(parsed.schoolState || '');
        setGrades(parsed.grades || []);
        setEthnicities(parsed.ethnicities || []);
        setStudentCountries(parsed.studentCountries || '');
        setStudentInterests(parsed.studentInterests || '');
      } catch (error) {
        console.error('Error parsing teacherProfile cookie:', error);
      }
    }
  }, []);

  // Handle checkboxes
  const handleGradeChange = (e) => {
    const value = e.target.value;
    setGrades((prev) =>
      prev.includes(value) ? prev.filter((g) => g !== value) : [...prev, value]
    );
  };

  const handleEthnicityChange = (e) => {
    const value = e.target.value;
    setEthnicities((prev) =>
      prev.includes(value) ? prev.filter((e) => e !== value) : [...prev, value]
    );
  };

  // Submit and save data
  const handleSubmit = (e) => {
    e.preventDefault();
    const profileData = {
      schoolName,
      schoolDistrict,
      schoolCity,
      schoolState,
      grades,
      ethnicities,
      studentCountries,
      studentInterests,
    };

    // Save to localStorage
    localStorage.setItem('teacherProfile', JSON.stringify(profileData));

    // Save to cookie (expires in 30 days)
    Cookies.set('teacherProfile', JSON.stringify(profileData), { expires: 30 });

    // Redirect
    navigate('/modulelist');
  };

  return (
    <form className="container mt-4" onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="form-label">
          <span className="text-danger">*</span> Your school name:
        </label>
        <input
          type="text"
          className="form-control"
          value={schoolName}
          onChange={(e) => setSchoolName(e.target.value)}
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label">
           <span className="text-danger">*</span> Your school district:
        </label>
        <input
          type="text"
          className="form-control"
          value={schoolDistrict}
          onChange={(e) => setSchoolDistrict(e.target.value)}
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label">
           <span className="text-danger">*</span> Your school city/town:
        </label>
        <input
          type="text"
          className="form-control"
          value={schoolCity}
          onChange={(e) => setSchoolCity(e.target.value)}
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label">
           <span className="text-danger">*</span> Your school state:
        </label>
        <select
          className="form-control"
          value={schoolState}
          onChange={(e) => setSchoolState(e.target.value)}
          required
        >
          <option value="">Select a state</option>
          {states.map((state, index) => (
            <option key={index} value={state}>{state}</option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label">
           <span className="text-danger">*</span> Grade(s) you want to use this customized project for:
        </label>
        <div className="form-check">
          {['3rd', '4th', '5th', '6th', '7th', '8th'].map((grade) => (
            <div key={grade}>
              <input
                className="form-check-input"
                type="checkbox"
                value={grade}
                checked={grades.includes(grade)}
                onChange={handleGradeChange}
              />
              <label className="form-check-label">{grade} grade</label>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">
          Race/ethnicities of your students: <span className="text-danger">*</span>
        </label>
        <div className="form-check">
          {[
            'American Indian or Alaska Native',
            'Asian',
            'Black or African American',
            'Hispanic or Latino(a)',
            'Native Hawaiian or Other Pacific Islander',
            'White',
            'Other'
          ].map((ethnicity) => (
            <div key={ethnicity}>
              <input
                className="form-check-input"
                type="checkbox"
                value={ethnicity}
                checked={ethnicities.includes(ethnicity)}
                onChange={handleEthnicityChange}
              />
              <label className="form-check-label">{ethnicity}</label>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">
          Countries where your students come from: <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          value={studentCountries}
          onChange={(e) => setStudentCountries(e.target.value)}
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label">
          Some shared interests or hobbies of your students: <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          value={studentInterests}
          onChange={(e) => setStudentInterests(e.target.value)}
          required
        />
      </div>

      <div className="text-center">
        <button type="submit" className="btn btn-primary">Continue</button>
      </div>
    </form>
  );
}

export default ProfileForm;